<template>
    <div style="padding:0 40px">
      <el-row type="flex" :gutter="8" v-if="currenPage==='home'">
        <div class="input-box-n1">
          <label class="input-box-lable1">增值服务</label>
          <div @click="toggleExpand" class="add_value_choose add_value_choose1" :style="currenPage==='home'?'height:32px;line-height:32px;background:#F2F3F5;border:none;':''">
            <span v-if="marking_string">{{marking_string}}</span>
            <span v-else style="color:#C0C4CC">请选择</span>
            <img src="../assets/images/list_Choose.png" class="chooseIcon chooseIcon1" :class="expanded ? 'rotate180' : 'rotate'"/>
          </div>
        </div>
      </el-row>
      <el-row class="add_value" v-else>
        <el-col class="title" :span="2" >
            <div>增值服务</div>
        </el-col>
        <el-col class="input" :span="22">
            <div @click="toggleExpand" class="add_value_choose" :style="currenPage==='home'?'height:32px;line-height:32px;background:#F2F3F5;border:none;':''">
              <span v-if="marking_string">{{marking_string}}</span>
              <span v-else style="color:#C0C4CC">请选择增值服务</span>
              <img src="../assets/images/list_Choose.png" class="chooseIcon" :class="expanded ? 'rotate180' : 'rotate'"/>
            </div>
        </el-col>
      </el-row>
      <CollapseTransition>
        <div class="description" v-show="expanded">
           <!-- <div class="desItem flexBox" v-if="commonShow.ysmdShow">
              <div class="left">
                 <img src="../assets/images/ysmd.png" />
                 <span>隐私面单</span>
                 <small >（对快递员隐藏收寄件人的真实手机号，保护您的隐私）</small>
                 <div @click="setdefault('ys')" v-if="ys_switch" style="cursor: pointer"><img :src="ys_isdefault ? setpng : noset" class="setImg"> 设置为默认打开</div>
              </div>
              <div class="right">
                <el-switch v-model="ys_switch"></el-switch>
              </div>
           </div> -->
           <div class="desItem flexBox" v-if="commonShow.zcwShow">
              <div class="left">
                 <img src='../assets/images/zcw.png'/>
                 <span>智橙网</span>
                 <small >（额外付费1元，享受派前电联、优先派送等权益）</small>
                 <div @click="setdefault('zc')" v-if="zc_switch" style="cursor: pointer"><img :src="zc_isdefault ? setpng : noset" class="setImg"> 设置为默认打开</div>
              </div>
              <div class="right">
                <span style="color:red;padding-right: 4px;font-weight: bold;" v-if="zc_switch">￥ 1</span>
                <el-switch v-model="zc_switch" @change="onchange($event,'zc')"></el-switch>
              </div>
           </div>
           <div class="desItem flexBox" v-if="commonShow.sgjShow">
              <div class="left">
                 <img src='../assets/images/sgj.png'/>
                 <span>水果件</span>
                 <small >（专属面单标识、智能提醒、兜底赔付）</small>
                 <div @click="setdefault('sg')" v-if="sg_switch" style="cursor: pointer"><img :src="sg_isdefault ? setpng : noset" class="setImg"> 设置为默认打开</div>
              </div>
              <div class="right">
                <span style="color:red;padding-right: 4px;font-weight: bold;" v-if="sg_switch">￥ 0.1</span>
                <el-switch v-model="sg_switch" @change="onchange($event,'sg')"></el-switch>
              </div>
           </div>
           <div class="desItem" v-show="!bindnet" v-if="commonShow.bjShow">
              <div class="flexBox">
                <div class="left">
                    <img src='../assets/images/bj.png'/>
                    <span>保价</span>
                    <small >（贵重物品推荐保价，未保价物品最多赔付3倍运费）</small>
                </div>
                <div class="right">
                    <el-switch v-model="bj_switch" @change="onchange($event,'bj')"></el-switch>
                </div>               
              </div>
              <div class="inputBox" v-if="bj_switch">
                <el-input v-model="bj_value" placeholder="请输入物品的价值，1-50000元" size="small"  onkeyup="value=value.replace(/[^\d]/g,'')" @input="bj_input" @blur="getbjpay"></el-input>
              </div>
              <div class="desinfo" v-if="bj_switch">
                 <div class="xieyi" @click="powerOpen('bj')">《韵达快递保价说明》</div>
                 <div>保费 :<span style="color:red">￥{{bj_pay? bj_pay: '--'}}</span></div>
              </div>
           </div>
           <div class="desItem" v-show="!bindnet" v-if="commonShow.dshkShow">
             <div class="flexBox">
              <div class="left">
                 <img src='../assets/images/dsdk.png'/>
                 <span>代收货款</span>
                 <small >（快递员代下单者向收货方收取货款）</small>  
              </div>
              <div class="right">
                <el-switch v-model="ds_switch" @change="onchange($event,'ds')"></el-switch>
              </div>                
             </div>
             <section v-if="ds_switch">
             <div class="inputBox">
                <el-input v-model="ds_value" placeholder="请输入代收货款，最高10000元" size="small"  onkeyup="value=value.replace(/[^\d]/g,'')" @input="ds_input"></el-input>
             </div>
             <div class="desinfo">
                 <div class="xieyi"><el-checkbox v-model="agree_isdefault"></el-checkbox><small  @click="powerOpen('ds')">《韵达快递代收货款服务使用协议》</small></div>
                 <div>代收服务费 :<span style="color:red">￥{{ds_pay?ds_pay:'--'}}</span></div>
              </div>
             <div class="destips"><small>温馨提示：代收服务服务费率为0.8%，不足2元，按照2元收取，最高不超过80元</small></div>              
             </section>
           </div>
           <div class="desItem" v-show="!bindnet" v-if="commonShow.qdfhShow">
             <div class="flexBox">
              <div class="left">
                 <img src='../assets/images/qdfh.png'/>
                 <span>签单返回</span>
                 <small >（快递签收后，将收件人收货凭证单据寄给发件人）</small>
              </div>
              <div class="right">
                <span style="color:red;padding-right: 4px;font-weight: bold;" v-if="qd_switch">￥ 5</span>
                <el-switch v-model="qd_switch" @change="onchange($event,'qd')"></el-switch>
              </div>                
             </div>
             <section v-if="qd_switch">
             <div class="desinfo">
                <el-checkbox-group v-model="qd_index">
                  <el-checkbox :label="item.type" v-for="(item,index) in qdlist" :key="index"  @change="((e)=>{choose_qd_type(e,item.type)})">{{item.name}}</el-checkbox>
                </el-checkbox-group>
             </div>
             <div class="inputBox" style="padding-bottom:10px">
                <el-input v-model="remark" placeholder="留言给快递员描述签名/盖章位置，签单张数，限制20个字内" size="small" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" maxlength="20"></el-input>
             </div>
             </section>
           </div>
        </div>   
      </CollapseTransition>
      <el-dialog
        :title="powertype == 'ds' ? '韵达快递代收货款服务使用协议' : '韵达快递保价服务说明'"
        :visible.sync="powerShow"
        width="600px"
        center>
        <article v-if="powertype == 'bj'">
          <div>1、贵重物品请保价，若未选择保价则最高赔付3倍运费。</div>
          <div>2、寄件人交寄物品时请按照货物实际价值申报保价金额，并根据申报价值支付保费，未支付保费视为未保</div>
          <div>3、单件货物价值超过500元建议保价。</div>
          <div>4、申报货物价值最高50000元，超过50000元请拆包分开交寄，并单独申报价值。</div>
          <div>5、保价快件足额投保的情况下，按照实际损失赔付；快件未足额投保的情况下，按照损失比例赔付（赔付公式：理赔金额=保险金额/物品价值*实际损失）。</div>
          <div>6、申请理赔时请提供真实有效的价值证明（如发票，采购合同，交易凭证等)，如无法提供，则按照未报价快件迸行赔偿。</div>
          <div>7、以下物品不提供保价服务：</div>
          <div>  邮政航空等法律禁寄物品：如军火武器，货币，古董，金银珠宝，贵重金属，火药，汽油，高浓度酒精等；</div>
          <div>  国内无修复定损能力的精密物品：如工艺品，玉石，雕塑，模型，乐器等；</div>
          <div>  鲜活动植物，冷藏物：如花草，冷冻类，鲜肉，各类活体动物，动植物标本等；</div>
          <div>  无法估值的物品：文件，合同，票据，返厂维修的快件（保丢不保损）。</div>
          <div>8、保价费用收取规则：</div>
          <div><span class="text_indent more_black">普通商品：</span>保价金额1-1000元(含)时，保价费用为0.9元；保价金额在1000-2000元（含)时，保价费用为1.8元；保价金额在2000-10000元（含)时，保价费用=保价金额*2.7‰；保价金额大于10000元时，保价费用=保价金额*4.5‰；</div>
          <div><span class="text_indent more_black">特殊商品：</span>保价金额1-500元(含)时，保价费用为3.6元；保价金额在500-1000元(含)时，保价费用为4.5元；保价金额在1000-2000元(含)时保价费用为7.2元；保价金额大于2000元时，保价费用=保价金额*4.5‰；</div>
          <div><span class="text_indent more_black">特殊商品包括：</span>电子产品（包括电脑、手机、电视、数码影音产品等），易碎品（包括陶瓷制品、显像管；液体类易碎品、酒类；不可拆卸家具；展柜、门、天花板；大理石；玻璃制品；灯具类）。</div>
        </article>
        <article v-else>
         <div>【提示条款】</div>
         <div>您在签署或在线点击同意本协议或使用“韵达快递”代收货款服务（以下简称“代收货款服务”）之前，<span class="more_black under_line">请务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任、法律适用和争议解决等以粗体下划线格式特别标识的条款，您应重点阅读。</span></div>
         <div>若您签署或在线点击同意本协议或使用代收货款服务，即表示您已充分阅读、理解并接受本协议的全部内容。<span class="more_black under_line">本协议自您签署或点击同意本协议之时或使用代收货款服务的行为发生之时（以时间在先者为准）起生效。如您对本协议有任何疑问，或者不同意本协议或其中任何条款约定，请勿签署或点击同意本协议并立即停止使用代收货款服务。</span></div>
         <div>1．定义</div>
         <div>1.1.委托人：系指通过“韵达快递”下单寄件，并选择使用增值服务中的代收货款服务的用户，以下简称为您。</div> 
         <div>1.2.上海韵达货运有限公司系指依法设立、取得快递业务经营许可证，拥有“韵达快递”、“YD”注册商标，从事快递业务的有限公司，以下简称韵达快递。</div>
         <div>1.3.快递服务组织系指依法设立，经上海韵达货运有限公司授权使用“韵达快递”、“YD”注册商标，从事快递业务，自主承担快递服务法律责任的企业法人，是本协议项下实际提供快件揽收、派送以及代收货款服务的快递营业机构，<span class="more_black under_line">委托人系与快递服务组织直接建立快递服务合同关系，以下简称当地揽件/派件网点。</span></div>
         <div>1.4.代收货款服务：是指您通过“韵达快递”下单寄件并选择增值服务中的代收货款服务，韵达快递通过代收货款平台代为收取货款以及返款的服务。</div>
         <div>2.协议内容及变更</div>
         <div>2.1.本协议内容包括协议正文、附件及所有韵达快递已经发布的或将来可能发布的平台规则。<span class="more_black under_line">所有附件及平台规则均为本协议不可分割的一部分，与协议正文具有同等法律效力。协议正文、附件与平台规则相冲突的，以发布在后的文件为准执行。</span></div>
         <div>2.2.韵达快递有权根据需要不时地变更（包括但不限于制定、修订、废止）本协议正文、附件及/或平台规则，并按本协议约定方式通知您，<span class="more_black under_line">如您不同意变更事项，应当立即停止使用代收货款服务，如您继续使用代收货款服务，则视为您同意前述变更事项，变更事项自通知您之时起生效。</span></div>
         <div>3.开通与使用</div>
         <div>3.1.用户资格</div>
         <div>您确认，您具备中华人民共和国法律规定的与您行为相适应的民事行为能力。<span class="more_black under_line">若您不具备前述民事行为能力，则您及您的监护人应依照法律规定承担因此导致的一切后果。</span></div>
         <div>3.2.信息管理</div>
         <div>3.2.1.在使用代收货款服务时，您应当按照系统页面的提示准确完整地提供寄件人及收件人的信息（包括但不限于寄件人及收件人的联系电话、地址等），如前述信息发生变更，您应当及时提供最新、真实、完整的信息，以便韵达快递或其他用户能够及时与寄件人及收件人取得联系。</div>
         <div>3.2.2.<span class="more_black under_line">您了解并同意，您有义务保持您提供信息的真实性及有效性，如韵达快递按您提供的信息与您联系未果、您未按韵达快递要求及时提供信息、您提供的信息不实或失效的，韵达快递将按照平台规则处理，同时您应承担因此给您自身、他人及韵达快递造成的全部损失与不利后果。</span></div>
         <div>3.3.账户安全</div>
         <div>3.3.1.您的公众号登录账户（包括账户名、密码等，下同）由您自行设置并由您保管，韵达快递在任何时候均不会主动要求您提供账户，请您务必妥善保管账户。<span class="more_black under_line">因您主动泄露、保管不当而泄露或遭受他人攻击、诈骗等行为导致的损失及后果，韵达快递不承担任何责任。</span></div>
         <div>3.3.2.<span class="more_black under_line">您应当对您账户项下的所有行为结果（包括但不限于在线签署的各类协议等）负责。</span></div>
         <div>3.3.3.如发现任何未经授权使用您账户或其他可能导致您的账户遭窃、遗失的情况，建议您立即通知韵达快递，并授权韵达快递将该信息同步给韵达快递的关联公司或合作方。<span class="more_black under_line">您理解韵达快递对您的任何请求采取行动均需要合理时间，除韵达快递存在重大过错处，韵达快递对在采取行动前已经产生的后果不承担任何责任。</span></div>
         <div>4.代收货款服务及规范</div>
         <div>4.1.服务概况</div>
         <div>4.1.1.代收货款服务具体为以下内容：</div>
         <div>（一）<span class="more_black">您选择代收货款服务时，必须真实、准确的填写寄件人与收件人的姓名、地址、品名、代收金额等具体信息，并确保收件人电话与您希望委托快递服务组织代为收取货款的收件人手机号一致，如因不及时、不准确或者填写快递面单号和寄、收件人电话或者随意更换寄、收件人号码的，导致您无法收到或不能及时收到该票快件货款，您应当自行承担相应后果</span>。</div>
         <div>（二）<span class="more_black">您不得交寄法律法规禁止、限制寄递的物品和韵达快递不予寄递的物品（包括但不限于货币、有价证券、个人及单位证件证照等）。</span>并且您必须确保您所发的货物为您有权销售或处置的货物，与收件人要求购买的货物一致，且提供准确有效的收款凭证，收款凭证所载金额需与代收货款金额一致（如您与收件人约定无需代收货款凭证的，则不受此限），否则因此引起的快递服务组织的损失由您自行承担。快递服务组织仅负责交寄物品的寄递、收款，不对商品的质量保证、市场价值及其他售后服务承担责任。</div>
         <div>（三）您应向快递服务组织申报交寄物品的种类、品名等信息并配合快递服务组织取件人员验视。快递服务组织有权根据您申报信息及物品的包装信息进行验视；<span class="more_black">如您不配合验视的或采用隐匿、夹带、更改包装等方式逃避验视的，由此导致的相关责任由您承担。</span></div>
         <div>（四）您应当保证您交寄的物品不侵犯第三方的专利权、商标权、商业秘密（包括但不限于专有技术）等知识产权，亦不存在任何质量问题，如有发生，您应与第三方积极进行交涉，由此导致快递服务组织所有相关责任及赔偿将由您承担。</div>
         <div>（五）<span class="more_black">您应当对交寄的物品进行妥善包装，确保符合寄递条件；</span>您委托快递服务组织进行包装的，快递服务组织有权收取相应的包装费用。您对于寄递物品有特殊的包装运送要求的，应书面说明。</div>
         <div>4.2.费用与结算</div>
         <div><span class="more_red under_line">4.2.1.单笔代收货款的总价上限不超过10000元人民币（含10000元），且大于2元。您需按照韵达快递收费标准向韵达快递支付代收货款服务费。韵达快递收取的代收货款服务费按照单个包裹代收货款金额的8‰，最低2元/票计算。代收货款服务费将从代收金额中扣除后，由当地揽件网点将扣除代收货款服务费后的代收金额结算于您。请注意代收货款服务费不包括快递服务费，快递服务费需要您与当地揽件网点另行结算。</span></div>
         <div><span class="more_red under_line">4.2.2.您指定的收件人可采用现金或者扫码的方式进行支付，自您指定的收件人签收成功后3-4个工作日（具体时间由您与当地揽件网点协议为准），由当地揽件网点将订单金额扣除代收货款服务费后返还至您。</span></div>
         <div>4.2.3.如未来平台调整代收货款服务费收取标准的，平台将通过本协议约定的通知方式，以合理的期限提前通知您，确保您享有选择是否继续使用服务的权利。</div>
         <div>4.2.4.<span class="more_black under_line">您使用代收货款服务过程中的一切硬件、软件、服务及其他方面的费用，由您自行承担。</span></div>
         <div>4.3.争议处理</div>
         <div>4.3.1.<span class="more_black under_line">您知晓快递量的庞大，您对代收货款有异议时，应在发生争议后一个月内向平台点反馈并提供有效的证明材料，如逾期未反馈的视为无异议。</span></div>
         <div>4.3.2.<span class="more_black under_line">您在使用代收货款过程中与其他用户发生争议的，自知晓您与争议相对方应自行通过协商、调解、仲裁、诉讼等途径依法解决，或者申请平台介入调处。</span></div>
         <div>4.3.3.<span class="more_black under_line">您或争议相对方任一方申请韵达快递介入调处的，则韵达快递将作为独立的第三方，根据其所调查了解到的争议事实并依据平台规则作出调处决定</span>。</div>
         <div>4.3.4.如您或争议相对方任一方对韵达快递的调处决定不满意，仍有权采取其他争议处理途径解决争议，<span class="more_black under_line">但通过其他争议处理途径未取得终局决定之前，您与争议相对方仍应先行履行调处决定。</span></div>
         <div>4.4.责任限制</div>
         <div>4.4.1.您理解并同意，在争议调处中，韵达快递并非专业人士，仅能以普通人的认知水平对您或争议相对方提交的材料进行鉴别、对争议事实等做出判断。因此，<span class="more_black under_line">除恶意所致处，韵达快递对争议调处决定免责，如您因此遭受损失，您同意自行向受益人或致损方索赔。</span></div>
         <div>4.4.2.<span class="more_black under_line">韵达快递将按“现状”和“可得到”的状态向您提供代收货款服务，韵达快递按照法律规定保障平台的正常运作，但不对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，起义，骚乱，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。</span></div>
         <div><span class="more_red under_line">4.4.3.您使用第三方提供的与代收货款相关的任何服务时，请您自行与第三方就相关权利义务进行明确约定。韵达快递不对您与第三方之间的纠纷承担任何责任，发生收件人要求退货情形时，当地派件网点没有义务代您向收件人退款。</span></div>
         <div><span class="more_red under_line">4.4.4 您知晓实际为您提供代收货款服务的系本合同中约定的当地揽件网点并非韵达快递，您在快件发生丢损时，应向当地揽件网点主张，与韵达快递无关。</span></div>
         <div><span class="more_black under_line">5.用户信息保护、授权及使用</span></div>
         <div>5.1.个人信息的保护</div> 
         <div>韵达快递非常重视用户个人信息的保护，在您使用代收货款服务时，<span class="more_black under_line">您同意韵达快递按照相关法律法规之规定、本协议约定以及公布在韵达快递平台的隐私政策收集、存储、使用、披露和保护您的个人信息。</span></div> 
         <div>5.2.非个人信息的保证与授权</div> 
         <div>5.2.1.您声明并保证，<span class="more_black under_line">您对您所发布的信息拥有合法、充分的权利，否则，韵达快递有权对您发布的信息依法或依本协议进行删除或屏蔽，且您应保障韵达快递免于承担并补偿韵达快递因您违反上述规定而遭受的任何损失、损害。</span></div> 
         <div>5.2.2.<span class="more_black under_line">对于您在注册、激活账户或其他使用代收货款服务过程中提供、形成的除个人信息外的文字、图片、视频、音频等信息（非个人信息），您免费授予韵达快递及其关联公司全球范围的许可使用权利及再授权给其他第三方使用的权利。您同意韵达快递及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以目前已知或日后开发的形式、媒体或技术将上述信息纳入其他作品内</span>。</div> 
         <div>5.2.3.<span class="more_black under_line">为方便您使用韵达快递及其关联公司提供的其他相关服务，您授权韵达快递将您在注册、激活账户或其他使用代收货款服务过程中提供、形成的信息传递给其他相关服务提供者，或从其他相关服务提供者处获取您在注册、使用相关服务期间提供、形成的信息。</span></div> 
         <div>6.用户的违约及处理</div> 
         <div>6.1.违约认定</div> 
         <div>6.1.1.发生如下情形之一的，视为您违约：</div> 
         <div>（一）使用代收货款服务时违反相关法律法规规定的；</div> 
         <div>（二）虚假发货的或者所发货物您无权销售或者处置的或者与您所发货物与收件人应付价款不对应的；</div> 
         <div>（三）与快递服务组织串通损害韵达快递或第三人利益的；</div> 
         <div>（四）违反本协议及平台规则约定的。</div> 
         <div>6.2.违约处理措施</div> 
         <div>6.2.1.<span class="more_black under_line">韵达快递有权依据本协议或平台规则之规定，对您或者快递服务组织采取包括但不限于不结算服务款项等款项、限制账户权限、中止或终止合作或者向您追偿损失等处理措施。</span></div> 
         <div>6.3.赔偿责任</div> 
         <div>6.3.1.如您的行为致使韵达快递或韵达快递子公司、控股公司遭受损失，您应当赔偿韵达快递或韵达快递子公司、控股公司的全部损失。</div> 
         <div>6.3.2.如您的行为致使韵达快递或韵达快递子公司、控股公司遭受第三方主张权利，韵达快递或韵达快递子公司、控股公司有权在对第三方承担金钱给付等义务后就全部损失向您索赔。</div> 
         <div>6.3.3.<span class="more_black under_line">本协议中所称损失，包括但不限于直接经济损失、商誉损失，韵达快递对外支付的赔偿金、和解款、公证费、律师费、诉讼费等款项或费用，以及韵达快递为了避免损失扩大或维权而支出的取证费、差旅费等合理费用</span>。</div> 
         <div>6.4.特别约定</div> 
         <div>6.4.1.如您向韵达快递或韵达快递子公司、控股公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽淡范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，韵达快递有权立即终止与您的所有合作并向您收取违约金或赔偿金，该等金额以韵达快递因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。</div> 
         <div>6.4.2.<span class="more_black under_line">如因您违反了与韵达快递或韵达快递子公司、控股公司签署的其他协议导致韵达快递或韵达快递子公司、控股公司终止该等协议的，韵达快递有权中止甚至终止本协议，并以本协议约定的方式通知您。如因您违约导致韵达快递终止本协议的，韵达快递或韵达快递子公司、控股公司有权对您在其他协议项下的合作采取中止甚至终止协议的措施，并以本协议约定的方式通知您。</span></div> 
         <div>7.协议的终止</div> 
         <div>7.1.终止的情形</div> 
         <div>7.1.1.通知解除：协议任何一方均可以提前十五（15）日书面通知的方式解除本协议。</div> 
         <div>7.1.2.<span class="more_black under_line">韵达快递单方解除权：如您违反本协议中的任何约定、承诺、保证或任何平台规则，韵达快递都有权立刻解除本协议，并按照本协议约定或平台规则规定对您进行违约处理。</span></div> 
         <div>7.1.3.<span class="more_black under_line">如非因韵达快递的原因，您未能按本协议约定按期全额支付相关款项或费用的，韵达快递有权解除本协议。</span></div> 
         <div>7.1.4.本协议约定的其他终止条件发生或实现，导致本协议终止。</div> 
         <div>7.2.终止后事项</div> 
         <div>7.2.1.<span class="more_black under_line">本协议终止后，韵达快递有权保留您的注册信息及交易行为记录等数据，但韵达快递没有保存这些数据的义务，亦不承担向您或任何第三方提供任何数据信息的义务，也不就协议终止向您或任何第三方承担责任，但法律另有规定的除外。</span></div> 
         <div>7.2.2.<span class="more_black under_line">本协议终止后，协议有效期内已经执行的部分仍应按照实际履行情况及本协议约定进行，对于您过往的违约行为，韵达快递仍可依据本协议向您追究违约责任。</span></div> 
         <div>8.通知</div> 
         <div>8.1.通知方式与送达</div> 
         <div>8.1.1.本协议签订或履行过程中，韵达快递向您寄送的书面通知，在<span class="more_black under_line">交邮后第五（5）个自然日即视为送达，</span>您指定邮寄地址为您的户籍地址、住所地或您向韵达快递提供的其他联系地址。书面通知的形式还包括但不限于在“韵达快递”下单平台发布规则。在采用电子方式进行通知的情况下，<span class="more_black under_line">发送当日即视为送达。</span></div> 
         <div>8.1.2.您应保证提供的联系信息（包括但不限于户籍地址、住所地、联系地址、联系人、联系电话、电子邮箱，下同）真实、准确、有效，如信息变更应立即在“韵达快递”下单平台渠道更新，<span class="more_black under_line">如您未及时更新，向原联系方式送达仍视为有效送达。</span></div> 
         <div>9.法律适用与管辖</div> 
         <div>9.1.本协议的订立、履行、解释、变更及争议解决均适用<span class="more_black under_line">中华人民共和国法律（为避免歧义，不包含冲突法规则及港、澳、台地区法建）。</span></div> 
         <div>9.2.对于因本协议产生的或者与本协议有关的争议，应友好协商解决，协商不成的，协议任一方均可向<span class="more_black under_line">上海青浦区人民法院</span>提起诉讼。</div> 
         <div>10.其他</div> 
         <div>10.1.<span class="more_black under_line">如果根据适用的法律认定本协议中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性，这种无效、违法或者不具有可执行性不影响本协议中的任何其他条款的效力。</span></div> 
        </article>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="powerClose" size="small">{{powertype == 'bj'?'我知道了':'我已知晓并同意该协议'}}</el-button>
        </span>
      </el-dialog>
      <div style="height:350px" v-show="expanded" id="anchor"></div>
    </div>
</template>
<script>
import util from '@/util/util';
import CollapseTransition from './CollapseTransition';
import bindKdy from "@/api/bindKdy";
export default {
    name:'value_addservices',
    components: {
      CollapseTransition
    },
    props:{
      'initmore':{
        type:Boolean,
        default:true,
      },
      'currenPage':{
        type:String,
        default:'',
      }
    },
    data(){
        return {
            ys_switch:true,
            zc_switch:false,
            sg_switch:false,
            bj_switch:false,
            ds_switch:false,
            qd_switch:false,
            ys_isdefault:false,
            zc_isdefault:false,
            sg_isdefault:false,
            remark:'', // 备注
            qdlist:[
              {type:'1',name:'签名'},
              {type:'2',name:'盖章'},
              {type:'3',name:'登记身份证'},
            ],
            qd_index:['1'],
            agree_isdefault:false,
            bj_value:'', // 保价值
            bj_pay:'', //保费
            ds_value:'', // 代收货款值
            ds_pay:'', // 代收货款费
            expanded: false,
            setpng:require('../assets/images/beset.png'),
            noset:require('../assets/images/noset.png'),
            powerShow:false,
            powertype:'',
            marking_string:'',
            bindnet:false,
            commonShow:{
              ysmdShow:true,
              zcwShow:true,
              sgjShow:true,
              bjShow:true,
              dshkShow:true,
              qdfhShow:true,
            }
        }
    },
    computed:{
      changeSwitch(){
        const {ys_switch,zc_switch,sg_switch,bj_switch,ds_switch,qd_switch} = this;
        return {
          ys_switch,
          zc_switch,
          sg_switch,
          bj_switch,
          ds_switch,
          qd_switch
        }
      }
    },
    watch:{
      changeSwitch(newVal){
        let stringArr = [];
        // if(newVal.ys_switch) stringArr.push('隐私面单')
        if(newVal.zc_switch) stringArr.push('智橙网')
        if(newVal.sg_switch) stringArr.push('水果件')
        if(newVal.bj_switch) stringArr.push('保价')
        if(newVal.ds_switch) stringArr.push('代收货款')
        if(newVal.qd_switch) stringArr.push('签单返回')
        this.marking_string = stringArr.length ? stringArr.join('、') : ''
      }
    },
    mounted(){},
    methods: {
        init(){
          if(util.getCookie('ys_isdefault')==1){
            this.ys_isdefault = true;
            this.ys_switch = true;
          } 
          if(util.getCookie('zc_isdefault')==1){
            this.zc_isdefault = true;
            this.zc_switch = true;
          }
          if(util.getCookie('sg_isdefault')==1){
            this.sg_isdefault = true;
            this.sg_switch = true;
          }
          const old_sevices = util.getJsonValues(this.$store.state.commondict,'value_sevices') ?? ''
          let sevices = JSON.parse(old_sevices);
          console.log(sevices)
          this.commonShow.ysmdShow = sevices.ysmd;
          this.commonShow.zcwShow = sevices.zcw;
          this.commonShow.sgjShow = sevices.sgj;
          this.commonShow.bjShow = sevices.bj;
          this.commonShow.dshkShow = sevices.dshk;
          this.commonShow.qdfhShow = sevices.qdfh;
          console.log(this.$store.state.bindKdy)
          if(this.$store.state.bindKdy == 10 || this.$store.state.bindKdy == 12){
            this.bindnet = true; 
          }
        },
        value_checkRrror(){
          if(this.bj_switch){
            if(!this.bj_value){
              util.gj_message('请输入保价物品价值金额')
              return false
            }
            if(this.bj_value < 1){
              util.gj_message('保价物品价值金额不可小于1元')
              return false
            }
            if(this.bj_value > 50000){
              util.gj_message('保价物品价值金额不可大于50000元')
              return false
            }
          }
          if(this.ds_switch){
            if(!this.ds_value){
              util.gj_message('请输入代收货款金额')
              return false
            }
            if(this.ds_value < 2){
              util.gj_message('代收货款金额不可小于2元')
              return false
            }
            if(this.ds_value > 10000){
              util.gj_message('代收货款金额不可大于10000元')
              return false
            }
            if(!this.agree_isdefault){
              util.gj_message('请同意并勾选《韵达快递代收货款服务使用协议》')
              return false
            }
          }
          return true
        },
        getbjpay(){
          const query = {
            item_type: util.stringthingType(this.$parent.typeContent), 
            price_of_product: this.bj_value,
          }
          bindKdy.queryInsured(this,query).then(res=>{
            if(res.success){
              this.bj_pay = res.data
            }else{
              this.bj_pay = ''
            }
          })
        },
        bj_input(value){
          if(value < 1 || value > 50000){
            util.gj_message('请输入1-50000之间的整数')
          }
          if(value > 50000){
            this.bj_value = 50000
            return
          }
          this.bj_value = value
        },
        ds_input(value){
          if(value < 2) util.gj_message('代收货款金额必须大于2元')
          if(value > 10000) util.gj_message('代收货款金额不能超过1万元'); 
          if(value <= 250){
            this.ds_pay = 2
          }else if(value >= 10000){
            this.ds_pay = 80
          }else{
            this.ds_pay = (value*0.008).toFixed(2)
          }
          this.ds_value = value 
        },
        powerOpen(type){
           this.powertype = type;
           this.powerShow = true;
        },
        powerClose(){
          this.powerShow = false;
          if(this.powertype == 'ds'){
            this.agree_isdefault = true;
          } 
        },
        onchange(e,type){
          let map = {'ys':'ys_switch','zc':'zc_switch','sg':'sg_switch','bj':'bj_switch','ds':'ds_switch','qd':'qd_switch'};
          let switchType = map[type];
          const Istopay = this.$parent.maiServe == 'topay' ? true :false
          if(this.sg_switch && Istopay){
            this.sg_switch = false;
            util.gj_message('到付件不支持水果件!')
            return
          }
          if(this.bj_switch && Istopay){
            this.bj_switch = false;
            util.gj_message('到付件不支持保价!')
            return
          }  
          if(this.ds_switch && Istopay){
            this.ds_switch = false;
            util.gj_message('到付件不支持代收货款!')
            return
          }   
          if(this.qd_switch && Istopay){
            this.qd_switch = false;
            util.gj_message('到付件不支持签单返回!')
            return
          }
          if(this.sg_switch && (
            this.zc_switch || 
            this.bj_switch ||
            this.ds_switch ||
            this.qd_switch
            )){
            console.log(switchType,this[switchType])
            this[switchType] = false
            util.gj_message('水果件不支持其他增值服务!')
            return
          }
          if(this.bj_switch && !this.initmore){
            this.bj_switch = false;
            util.gj_message('编辑订单暂不支持保价!')
            return
          }  
          if(this.ds_switch && !this.initmore){
            this.ds_switch = false;
            util.gj_message('编辑订单暂不支持代收货款!')
            return
          }   
          if(this.qd_switch && !this.initmore){
            this.qd_switch = false;
            util.gj_message('编辑订单暂不支持签单返回!')
            return
          }
          if(!this.bj_switch && !this.ds_switch && !this.qd_switch){
            this.$emit('servicesType',false)
          }else{
            this.$emit('servicesType',true)
          }
        },
        choose_qd_type(e,val){
          if(this.qd_index.length == 0 && !e){
            this.qd_index.push(val) 
            return 
          }
        },
        toggleExpand (){
          if(!this.$parent.typeContent){
            util.gj_message('请先选择物品类型')
          }else{
            this.expanded = !this.expanded;  
            if(this.expanded){
              // this.init()
              this.$nextTick(()=>{
                document.querySelector('#anchor').scrollIntoView({
                  behavior: "smooth", 
                  block: "center",
                  inline: "nearest" 
                })                
              })
            }
          }
        },  
        setdefault(type){
          let map = {'ys':'ys_isdefault','zc':'zc_isdefault','sg':'sg_isdefault'}
          this[map[type]] = !this[map[type]];
          if(this[map[type]]){
            util.setCookie(map[type],1)
          }else{
            util.setCookie(map[type],0)
          }
        },
        oncenews(ys,zc,morder_marking_infos,isnew){
          this.init();
          if(isnew){
            let stringarr = [];
            if(ys == 'PRI'){
              this.ys_switch = true
              stringarr.push('隐私面单');
            }else{
              this.ys_switch = false
            }
            if(zc == 'TK'){
              this.zc_switch = true
              stringarr.push('智橙网');
            }else{
              this.zc_switch = false
            }
            if(morder_marking_infos){
              //保价
              if(morder_marking_infos.is_sgj == 1){
                this.sg_switch = true;
                // this.bj_value = morder_marking_infos.insured_value;
                // this.bj_pay = morder_marking_infos.insured_pay;
              }
              //保价
              if(morder_marking_infos.is_insured == 1){
                this.bj_switch = true;
                this.bj_value = morder_marking_infos.insured_value;
                this.bj_pay = morder_marking_infos.insured_pay;
              }
              //代收货款
              if(morder_marking_infos.is_cod == 1){
                this.ds_switch = true;
                this.ds_value = morder_marking_infos.cod_value;
                this.ds_pay = morder_marking_infos.code_pay;
              }
              //签单返回
              if(morder_marking_infos.is_return == 1){
                this.qd_switch = true
                this.remark =  morder_marking_infos.return_remark
                this.qd_index = morder_marking_infos.return_value.split(",")
              }            
            }
          }
          if(this.ys_switch || this.zc_switch|| this.bj_switch || this.ds_switch || this.qd_switch){
            this.expanded = true
          }
        },
        besure(){
          let obj = {};
          let marking_infos = []
          //水果件
          if(this.sg_switch){
            marking_infos.push({
                pay: '',
                pay_types: '',
                recept_no: "",
                remark: "",
                value_add_type: "SGJ",
                value_add_value: ''
            }) 
          } 
          //保价
          if(this.bj_switch){
            marking_infos.push({
                pay: this.bj_pay,
                pay_types: '',
                recept_no: "",
                remark: "",
                value_add_type: "INSURED",
                value_add_value: this.bj_value
            }) 
          } 
          //代收货款
          if(this.ds_switch){
            marking_infos.push({
                pay: this.ds_pay,
                pay_types: '',
                recept_no: "",
                remark: "",
                value_add_type: "COD",
                value_add_value: this.ds_value,
            })
          }
          //签单返回
          if(this.qd_switch){
            marking_infos.push({
                pay: "",
                pay_types: this.qd_index.join(','),
                recept_no: "",
                remark: this.remark,
                value_add_type: "RETURN",
                value_add_value: ""
            })    
          }
          obj = {
            ys_switch:this.ys_switch,
            zc_switch:this.zc_switch,
            marking_infos
          }
          return obj 
        }
    },
}
</script>
<style lang="stylus" scoped>
.add_value{
  display: flex;
  font-size: 13px;
  margin-top:10px;
  margin-bottom: 10px;
  justify-content: space-between; 
  .add_value_choose{
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    padding: 0 36px;
    width: 97%;
    float: left;
    text-align: right;
    position:relative;
    .chooseIcon{
      position: absolute;
      right: 10px;
      width: 16px;
      height: 16px;
      top: 12px;
      z-index: 10;
    }
  }
}
.title{
    text-align: right;
    margin-right: 10px;
    color: #212121;
    margin-top: 10px;
}
.description{
    padding: 10px 12px 10px 12px;
    border-radius: 12px;
    background: #f5f5f5;
    float: right; 
    width: 95%;
    .flexBox{
        display: flex;
        justify-content: space-between; 
        height: 40px;
        line-height: 40px;        
    }
    .inputBox{
        width :500px;
        padding-left: 40px;
    }
    .desinfo{
        padding-left: 40px;
        display: flex;
        width: 500px;
        justify-content: space-between;
        height: 40px;
        line-height: 40px;
        .xieyi{
            font-size: 12px;
            color:#409EFF;
            cursor: pointer;
        }
    }
    .destips{
        color:rgb(144, 147, 153);
        padding-left: 40px;
        padding-bottom: 12px;
    }
    .desItem{
        border-bottom: 1px solid #DCDFE6;
        font-size: 13px;
        .left{
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            align-items: center;
            img{
                width: 30px;
                height: 30px;
                padding-right: 10px;
            }
            .setImg{
                padding-left: 10px;
                width: 16px;
                height: 16px;
                vertical-align: text-bottom;
                padding-right: 0px;
            }
            small{
                color:rgb(144, 147, 153);
            }
        }
    }
}
article{
  height: 400px;
  overflow-y: auto;
}
.more_black{
  color:#303133;
  font-weight: bold;
}
.under_line{
  text-decoration: underline;
}
.more_red{
 color:red;
 font-weight: bold;
}
.text_indent{
 padding-left:20rpx;
}
.rotate180{
 transform: rotate(180deg); 
 transition: All 0.3s ease-in-out;
}
.rotate{
  transform: rotate(0deg); 
  transition: All 0.3s ease-in-out;
 }
.input-box-n1{
  height:32rpx;
  line-height:32rpx;
  display:flex;
  align-items: flex-start;
  margin:16px 0 16px 0;
  .input-box-lable1{
    height: 22px;
    color: rgba(29,33,41,1);
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
    text-align: left;
    line-height: 22px;
    padding:5px 0;
    margin-right:16px;
    span{
      color:#F53F3F;
      margin-right:8px;
      opacity:0;
    }
  }
  .add_value_choose1{
    width:763px;
    height:32px;
    line-height:32px;
    border-radius:4px;
    text-align:right;
    color: rgba(134,144,156,1);
    font-size: 14px;
    font-weight: 400;
    font-family: "PingFang SC";
  position: relative;
  }
  .chooseIcon1{
    width: 12px;
    height: 12px;
    top: 10px;
    right:12px;
    margin-right: 12px;
    margin-left:4px;
    z-index: 10;
  }
  }
</style>